import axios from "axios"
import api from "../api/BaseApi"
import { PDFDocument } from "pdf-lib"
import {
  ON_GET_BARCODE_SUCCESS,
  ON_GET_BARCODE_FAIL,
  ON_CLEAR_BARCODE,
  ON_LOAD_BARCODE,
  ON_ADD_TO_PRINT_LIST,
  ON_REMOVE_FROM_PRINT_LIST,
  ON_GET_BARCODE_LIST_SUCCESS,
  ON_GET_BARCODE_LIST_FAIL,
  ON_LOAD_BARCODE_LIST,
  CLEAR_BARCODE_LIST,
  CLEAR_ORDER_IDS_FOR_PRINT,
  ON_CLEAR_PDF_LIST_REQUEST,
  ON_PRINT_PDF_LIST_SUCCESS,
  ON_PRINT_PDF_LIST_FAIL,
} from "./types"

export const onLoadBarcodePDF = () => {
  return (dispatch) => {
    dispatch({
      type: ON_LOAD_BARCODE,
    })
  }
}

export const clearBarcodePDF = () => {
  return (dispatch) => {
    dispatch({
      type: ON_CLEAR_BARCODE,
    })
  }
}

export const getBarcodePDF = (packageNumber) => {
  return (dispatch) => {
    const options = {
      headers: {
        Authorization: axios.defaults.headers.common["Authorization"],
      },
      responseType: "blob",
    }
    axios
      .get(api.getBarcodePDF(packageNumber), options)
      .then((response) => {
        dispatch({
          type: ON_GET_BARCODE_SUCCESS,
          payload: window.URL.createObjectURL(response.data),
        })
      })
      .catch((error) => {
        console.log("BarcodeActions Error: " + error)
        dispatch({
          type: ON_GET_BARCODE_FAIL,
          payload: null,
        })
      })
  }
}

export const addToPrintList = (packageNumber, orderNumber) => {
  return (dispatch) => {
    dispatch({
      type: ON_ADD_TO_PRINT_LIST,
      payload: { packageNumber, orderNumber },
    })
  }
}

export const removeFromPrintList = (packageNumber, orderNumber) => {
  return (dispatch) => {
    dispatch({
      type: ON_REMOVE_FROM_PRINT_LIST,
      payload: { packageNumber, orderNumber },
    })
  }
}

export const getBarcodesPDFList = (packageNumbersList) => {
  return (dispatch) => {
    dispatch({
      type: ON_LOAD_BARCODE_LIST,
    })
    const options = {
      headers: {
        Authorization: axios.defaults.headers.common["Authorization"],
      },
    }
    axios
      .post(api.getBarcodesPDFList, packageNumbersList, options)
      .then((response) => {
        dispatch({
          type: ON_GET_BARCODE_LIST_SUCCESS,
          payload: response.data,
        })
      })
      .catch((error) => {
        console.log("BarcodeActions Error: " + error)
        dispatch({
          type: ON_GET_BARCODE_LIST_FAIL,
          payload: null,
        })
      })
  }
}

export const clearBarcodesPDFList = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_BARCODE_LIST,
    })
  }
}

export const clearOrderIdsForPrint = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_ORDER_IDS_FOR_PRINT,
    })
  }
}

export const printAllPDFs = (pdfList) => {
  return async (dispatch) => {
    try {
      const mergedPdf = await PDFDocument.create()

      for (const pdf of pdfList) {
        const uint8Array = base64ToArrayBuffer(pdf.fileContents)
        const existingPdf = await PDFDocument.load(uint8Array)
        const copiedPages = await mergedPdf.copyPages(
          existingPdf,
          existingPdf.getPageIndices()
        )
        copiedPages.forEach((page) => mergedPdf.addPage(page))
      }

      const mergedPdfBytes = await mergedPdf.save()
      const mergedBlob = new Blob([mergedPdfBytes], { type: "application/pdf" })
      const mergedUrl = URL.createObjectURL(mergedBlob)

      const iframe = document.createElement("iframe")
      iframe.style.display = "none"
      iframe.src = mergedUrl
      document.body.appendChild(iframe)

      iframe.onload = () => {
        iframe.contentWindow.print()
      }

      dispatch({ type: ON_PRINT_PDF_LIST_SUCCESS })
    } catch (error) {
      dispatch({ type: ON_PRINT_PDF_LIST_FAIL, payload: error })
    }
  }
}

export const clearPDFListRequest = () => {
  return (dispatch) => {
    dispatch({
      type: ON_CLEAR_PDF_LIST_REQUEST,
    })
  }
}

const base64ToArrayBuffer = (base64) => {
  const binaryString = window.atob(base64)
  const len = binaryString.length
  const bytes = new Uint8Array(len)
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return bytes.buffer
}
